import { defineComponent as _defineComponent } from 'vue';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { BAlert, BModal } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useHistoryStore } from "@/stores/historyStore";
import { absPath } from "@/utils/redirect";
import { urlData } from "@/utils/url";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import DataDialog from "@/components/DataDialog/DataDialog.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VisualizationPanel',
    setup(__props) {
        const { currentHistoryId } = storeToRefs(useHistoryStore());
        const router = useRouter();
        const plugins = ref([]);
        const query = ref("");
        const isLoading = ref(true);
        const currentPlugin = ref(null);
        const compatibleDatasetIdKeys = ref([]);
        const showDataDialog = ref(false);
        const showNoCompatibleDatasetsModal = ref(false);
        const filteredPlugins = computed(() => {
            const queryLower = query.value.toLowerCase();
            return plugins.value.filter((plugin) => !query.value ||
                plugin.html.toLowerCase().includes(queryLower) ||
                (plugin.description && plugin.description.toLowerCase().includes(queryLower)));
        });
        function createVisualization(dataset) {
            showDataDialog.value = false;
            if (currentPlugin.value) {
                router.push(`/visualizations/display?visualization=${currentPlugin.value.name}&dataset_id=${dataset.id}`, {
                    // @ts-ignore
                    title: dataset.name,
                });
            }
        }
        async function selectVisualization(plugin) {
            currentPlugin.value = plugin;
            compatibleDatasetIdKeys.value = await getCompatibleDatasetsInCurrentHistory();
            if (compatibleDatasetIdKeys.value.length === 0) {
                showNoCompatibleDatasetsModal.value = true;
                return;
            }
            showDataDialog.value = true;
        }
        /**
         * Get compatible datasets in the current history for the selected visualization.
         * @returns {Promise<string[]>} List of compatible datasets as "type-id" strings. In this case, type will be always "dataset".
         */
        async function getCompatibleDatasetsInCurrentHistory() {
            if (!currentPlugin.value || !currentHistoryId.value) {
                return [];
            }
            const result = (await urlData({
                url: `/api/plugins/${currentPlugin.value.name}`,
                params: { history_id: currentHistoryId.value },
            }));
            return result.hdas.map((dataset) => `dataset-${dataset.id}`);
        }
        async function getPlugins() {
            plugins.value = await urlData({ url: "/api/plugins" });
            isLoading.value = false;
        }
        onMounted(() => {
            getPlugins();
        });
        return { __sfc: true, currentHistoryId, router, plugins, query, isLoading, currentPlugin, compatibleDatasetIdKeys, showDataDialog, showNoCompatibleDatasetsModal, filteredPlugins, createVisualization, selectVisualization, getCompatibleDatasetsInCurrentHistory, getPlugins, faEye, BAlert, BModal, absPath, DelayedInput, DataDialog, LoadingSpan, ActivityPanel };
    }
});
